<template>
    <div class="menu-tools">
        <el-button icon="arrow-left" type="text" @click="goback">返回</el-button>
        &nbsp;&nbsp; <slot></slot>
    </div>
</template>
<script>
export default {
    methods: {
        goback() {
            this.$router.go(-1);
        }
    }
}
</script>
<style scoped>
.menu-tools {
    border-bottom: 1px solid #e7eaec;
    padding-bottom: 10px;
}
</style>



// WEBPACK FOOTER //
// src/components/BackTool/index.vue